module.exports = __webpack_public_path__ + "img/tutorial-f04-05.8d38c196.png";